import { SANTA_MEMBERS_APP_ID, MEMBERS_APP_ID } from '@wix/communities-universal/dist/src/constants/appsConfig';
import { getApplicationConfigFromContext, getCommunitiesContext } from '../selectors/communities-context-selectors';
import { isOneApp } from '@wix/communities-blog-client-common/dist/src/selectors/search-params-selectors';
import blogInOneAppNavigation from './navigation-provider/blog-in-one-app';
import blogWithMembersAppNavigation from './navigation-provider/blog-with-members-app';
import blogWithMembersAreaNavigation from './navigation-provider/blog-with-members-area';
import blogWithoutAppsNavigation from './navigation-provider/blog-without-apps';

export const createNavigationStrategy = ({ communitiesContext, isOneApp }) => {
  if (isOneApp) {
    return blogInOneAppNavigation;
  }
  if (getApplicationConfigFromContext(communitiesContext, SANTA_MEMBERS_APP_ID).isInstalled) {
    return blogWithMembersAreaNavigation;
  }
  if (getApplicationConfigFromContext(communitiesContext, MEMBERS_APP_ID).isInstalled) {
    return blogWithMembersAppNavigation;
  }
  return blogWithoutAppsNavigation;
};

export const createNavigation = store => {
  const state = store.getState();
  return createNavigationStrategy({
    communitiesContext: getCommunitiesContext(state),
    isOneApp: isOneApp(state),
  });
};
